var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showComments
        ? _c(
            "b-row",
            { staticClass: "m-0 w-full" },
            [
              _c("b-col", { attrs: { lg: "12" } }, [
                _c("h5", { staticClass: "mt-2 mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.comments.title")))
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.showComments
        ? _c(
            "b-row",
            { staticClass: "m-0" },
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c("vs-divider"),
                  !_vm.hasComments
                    ? _c("span", { staticClass: "small" }, [
                        _vm._v(_vm._s(_vm.$t("newsletter.comments.not_found")))
                      ])
                    : _vm._e(),
                  _c(
                    "ul",
                    { staticClass: "vx-timeline" },
                    _vm._l(_vm.comments, function(item) {
                      return _c("li", { key: item.id }, [
                        _vm.showHandlingComment
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: {
                                      content: item.public_access
                                        ? "Bloquear comentário"
                                        : "Liberar comentário",
                                      delay: { show: 500, hide: 100 }
                                    },
                                    expression:
                                      "{content: item.public_access ? 'Bloquear comentário' : 'Liberar comentário', delay: { show: 500, hide: 100 }}"
                                  }
                                ],
                                staticClass: "timeline-icon cursor-pointer",
                                class: item.public_access
                                  ? "bg-primary"
                                  : "bg-danger",
                                on: {
                                  click: function($event) {
                                    return _vm.handlingComment(item)
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass:
                                    "text-white stroke-current w-5 h-5",
                                  attrs: {
                                    icon: item.public_access
                                      ? "CheckIcon"
                                      : "XIcon"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "timeline-info" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-break break-all whitespace-pre-line"
                            },
                            [_vm._v(_vm._s(item.content))]
                          )
                        ]),
                        _c(
                          "small",
                          { staticClass: "text-grey activity-e-time" },
                          [_vm._v(_vm._s(_vm.formatTime(item.created_at)))]
                        )
                      ])
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }